export const ROLE_CONFIG = {
  organizer: {
    type: 'organizer',
    listingTitle: 'navigation.myEvents',
    listingDescription: 'events.eventsDescription',
    listingDescription2: 'events.eventsDescription2',
    listingDescription3: '',
    addButtonLabel: 'events.addEvent',
    canAddEvents: true,
    canEditEventSponsorImage: false,
    showUnverifiedTab: true,
    dashboardAccess: {
      enabled: true,
      dashboardComponents: {
        completedOrders: true,
        summaryCardSales: {
          canViewTotalOrders: true,
          canViewTotalAlbumSalesAmount: true,
          canViewTotalAlbumsSold: true,
          canViewTotalPhotosSold: true,
          canViewCommissionsEarned: true,
          canWithdrawCommission: true
        }
      },
    },
    tabs: {
      verified: 'events.verifiedTab',
      unverified: 'events.unverifiedTab',
    },
    fields: {
      hasBib: true,
      photoPrice: true,
      albumPrice: true,
      authorsCommission: true,
    },
    cardActions: [
      {
        name: 'goToDashboard',
        label: 'events.button',
        color: 'primary',
        icon: 'dashboard',
        outline: false
      },
    ],
  },
  sponsor: {
    type: 'sponsor',
    listingTitle: 'navigation.myEvents',
    listingDescription: 'events.eventsDescription',
    listingDescription2: '',
    listingDescription3: '',
    addButtonLabel: null,
    canAddEvents: false,
    canEditEventSponsorImage: true,
    showUnverifiedTab: false,
    dashboardAccess: {
      enabled: true,
      dashboardComponents: {
        completedOrders: false,
        albumViewsTable: true,
        summaryCardSales: {
          canViewTotalOrders: true,
          canViewTotalAlbumSalesAmount: true,
          canViewTotalAlbumsSold: true,
          canViewTotalPhotosSold: true,
          canViewCommissionsEarned: false,
          canWithdrawCommission: false
        }
      },
    },
    tabs: {
      verified: 'events.verifiedTab',
      unverified: null,
    },
    fields: {},
    cardActions: [
      {
        name: 'goToDashboard',
        label: 'events.button',
        color: 'primary',
        icon: 'dashboard',
        outline: false
      },
      {
        name: 'manageAssets',
        label: 'events.sponsorAssets.button',
        color: 'secondary',
        icon: 'folder_open',
        outline: true
      },
      {
        name: 'manageSponsorImage',
        label: '',
        color: 'secondary',
        icon: 'image',
        outline: true
      },
    ],
  },
  photographer: {
    type: 'photographer',
    listingTitle: 'events.photographer.myEvents',
    listingDescription: 'events.photographer.eventsDescription',
    listingDescription2: 'events.eventsDescription2',
    listingDescription3: 'events.photographer.eventsDescription3',
    addButtonLabel: 'events.addEvent',
    canAddEvents: true,
    canEditEventSponsorImage: false,
    showUnverifiedTab: true,
    dashboardAccess: {
      enabled: false,
      dashboardComponents: {}
    },
    tabs: {
      verified: 'events.verifiedTab',
      unverified: 'events.unverifiedTab',
    },
    fields: {
      hasBib: false,
      photoPrice: true,
      albumPrice: true,
      authorsCommission: false,
    },
    cardActions: [
      {
        name: 'uploadPhotos',
        label: 'dashboard.menu.addPhoto',
        color: 'secondary',
        icon: 'upload',
        outline: true
      },
      {
        name: 'goToAlbum',
        label: 'events.goToAlbum',
        color: 'secondary',
        icon: 'photo_library',
        outline: true
      },
    ],
  },
};

export function getRoleConfig(userRole) {
  return ROLE_CONFIG[userRole] || ROLE_CONFIG.organizer;
}

export function canUserAddEvents(userRole) {
  const config = getRoleConfig(userRole);

  return config.canAddEvents;
}

export function canViewDashboard(userRole) {
  const config = getRoleConfig(userRole);

  return !!config.dashboardAccess.enabled;
}

export function canViewCompletedOrders(userRole) {
  const config = getRoleConfig(userRole);

  return !!config.dashboardAccess.dashboardComponents.completedOrders;
}

export function canViewAlbumViewsTable(userRole) {
  const config = getRoleConfig(userRole);

  return !!config.dashboardAccess.dashboardComponents.albumViewsTable;
}

export function getSummarySalesPermissions(userRole) {
  const config = getRoleConfig(userRole);

  return config.dashboardAccess.dashboardComponents.summaryCardSales;
}
